import { ref } from 'vue';
import type { IGame } from '@skeleton/core/types';

const cachedGames = ref<Record<string, IGame>>({});

export const useGameInfoCache = () => {
  const { getGamesInfo } = useCoreGamesApi();

  const fetchGameInfo = async (gameId: string): Promise<IGame | undefined> => {
    if (!gameId) return;
    if (cachedGames.value[gameId]) return cachedGames.value[gameId];

    try {
      const game = await getGamesInfo(gameId);
      cachedGames.value[gameId] = game;
      return game;
    }
    catch (e) {
      console.error(`Failed to fetch game info for ID: ${gameId}`, e);
    }
  };

  return {
    fetchGameInfo,
  };
};
